// extracted by mini-css-extract-plugin
export default {"wrapper":"Blogs_wrapper__X0ml4","container":"Blogs_container__bcoPu"};